import * as classicApi from "@/api/podcasts.api"
import * as botApi from "@/api/podcastBot.api"

export const getPodcast = (podcastKey, isAiPodcast) =>
  isAiPodcast ? botApi.getAiPodcast(podcastKey) : classicApi.getPodcast(podcastKey)

export const updatePodcast = (podcastData, isAiPodcast) =>
  isAiPodcast
    ? botApi.updateAiPodcast(podcastData.key, podcastData, podcastData.logoFile ?? null)
    : classicApi.updatePodcast(podcastData)

export const deletePodcast = (podcastKey, isAiPodcast) =>
  isAiPodcast ? botApi.deleteAiPodcast(podcastKey) : classicApi.deletePodcast(podcastKey)
